import { useEffect, useState } from "react";
import EventBox from "./event_box";
import { API_STATUS } from "../../constants";
import { GetAllEvents } from "../../apis/event/get_all_event";
import PlaceHolder from "../../utils/placeholder";
import InfiniteScroll from "react-infinite-scroll-component";

export default function EventWrap() {

    const [GetEventApi, setGetEventApi] = useState(API_STATUS);
    const [EventData, setEventData] = useState([]);
    const [NoData, setNodata] = useState(false);
    const [offset, setOffset] = useState(0);
    const [moredata, setHasmore] = useState(true);

    useEffect(() => {
        GetAllEvents(offset, setGetEventApi);
    }, [offset]);

    const nextpage = () => {
        setOffset(offset + 15);
    }

    useEffect(() => {
        if (!GetEventApi.isError && !GetEventApi.isLoader && GetEventApi.data != null) {
            let res = GetEventApi.data;
            if (res['status'] === 1) {
                if (res['data'].length === 0) {
                    setNodata(true);
                    setHasmore(false);
                } else {
                    setEventData((prevItems) => [...prevItems, ...res['data']]);
                }
            } else {
                setNodata(true);
                setHasmore(false);
            }
        }
    }, [GetEventApi]);

    return <InfiniteScroll
        dataLength={EventData.length}
        next={nextpage}
        hasMore={moredata}
        loader={<PlaceHolder />}
    >
        <div className="md:max-w-[510px] mx-auto flex-1 xl:space-y-6 space-y-3">
            {
                GetEventApi.isLoader &&
                <PlaceHolder />
            }
            {
                EventData !== null && EventData.length > 0 &&
                <div className="flex-1 xl:space-y-6 space-y-3">
                    {
                        EventData.map((item) =>
                            <EventBox key={item.e_id} item={item} detail={false} />
                        )
                    }
                </div>
            }

            {
                NoData &&
                <div className="bg-white border border-slate-200 rounded-xl shadow-sm dark:border-slate-700 dark:bg-dark2">

                    <div className="relative md:gap-8 gap-4 items-center md:p-10 p-6">

                        <div className="flex-1">

                            <p className=" mt-1 font-normal">There is no events to show</p>

                        </div>
                    </div>
                </div>
            }

        </div>
    </InfiniteScroll>
}